module.exports = __webpack_public_path__ + "asset/image-pro-d390b2bbe387d24f.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/component/plans/component/plan/image/pro.png
// module id = 0rI6
// module chunks = 3